var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg08(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.329,
    height: 20.329,
    viewBox: "3.388 3.388 20.329 20.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 3.388H5.647a2.258 2.258 0 0 0-2.259 2.26v15.81a2.258 2.258 0 0 0 2.26 2.26h15.81a2.265 2.265 0 0 0 2.26-2.26V7.907L19.2 3.388Zm-5.647 18.07a3.384 3.384 0 0 1-3.388-3.387 3.384 3.384 0 0 1 3.388-3.389 3.384 3.384 0 0 1 3.388 3.389 3.384 3.384 0 0 1-3.388 3.388Zm3.388-11.293H5.647V5.647h11.294v4.518Z",
    fill: "#603f3f",
    fillRule: "evenodd",
    "data-name": "Tracciato 330"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08);
export default __webpack_public_path__ + "static/media/08.32a3a2928cd2864642d3d617cae6b7b0.svg";
export { ForwardRef as ReactComponent };